import { useEffect } from "react";

export const useBodyCustomScrollbar = () => {
  useEffect(() => {
    document.body.classList.add("nb-layout-app-body-scrollbar");
  }, []);
};
